// Several things can lock the page at once — the mobile drawer, a project
// modal, the command palette. A single owner would clobber the others on close,
// so locks are held by key and the body only unlocks when the last one lets go.

const held = new Set();

export function setScrollLock(key, locked) {
  if (locked) {
    held.add(key);
  } else {
    held.delete(key);
  }
  document.body.style.overflow = held.size > 0 ? 'hidden' : '';
}
